// browser file
import "./src/styles/global.css"
